var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F076A0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8634 25.0603C36.8634 25.0603 31.1041 23.3922 27.5725 21.9054C24.1721 20.4739 19.1366 17.6527 19.1366 17.6527",
    stroke: "white",
    strokeWidth: 1.7136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5996 38.3473H36.8066C37.6026 38.3473 38.2856 37.7592 38.3262 36.9643C38.3552 36.3971 38.3538 35.8319 38.3218 35.2646C38.2791 34.5059 37.6497 33.9279 36.8905 33.8964C35.5018 33.8387 34.2938 33.8387 32.9052 33.8964C32.146 33.9279 31.5166 34.5059 31.4739 35.2646C31.4162 36.2909 31.4581 37.3094 31.5996 38.3473Z",
    stroke: "white",
    strokeWidth: 1.7136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7012 38.3471H31.2977C31.4621 36.362 31.492 34.4204 31.3877 32.4513C31.347 31.684 30.7426 31.0682 29.976 31.0162C28.5994 30.9228 27.3995 30.9228 26.0229 31.0162C25.2563 31.0682 24.6519 31.684 24.6112 32.4513C24.5068 34.4204 24.5368 36.362 24.7012 38.3471Z",
    stroke: "white",
    strokeWidth: 1.7136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3042 38.3472H24.4C24.5753 35.3783 24.5978 32.4788 24.4674 29.5277C24.4339 28.7695 23.8593 28.1424 23.1038 28.0697C21.708 27.9355 20.4955 27.9355 19.0997 28.0697C18.3442 28.1424 17.7697 28.7695 17.7362 29.5277C17.6278 31.9804 17.625 34.3976 17.7278 36.8485C17.7631 37.6904 18.4614 38.3472 19.3042 38.3472Z",
    stroke: "white",
    strokeWidth: 1.7136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7383 26.8325C34.152 26.7126 35.8004 26.0032 36.8593 25.0591C36.7393 23.6455 36.0299 21.9971 35.0858 20.9382",
    stroke: "white",
    strokeWidth: 1.7136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/graphIcon.003a14cda2ad4e1c03573a82fd88d775.svg";
export { ForwardRef as ReactComponent };